import React, { useEffect } from "react";
import { Button, Form, Input, DatePicker, Select, TreeSelect, Row, Col } from "antd";
import { useModel } from "../../../models/index";

const { RangePicker } = DatePicker;
const rangeConfig = {
    rules: [{ type: 'array', required: false, message: '请选择制单时间!' }],
};
export default function () {
    const [form] = Form.useForm();

    const [{ materialSortDict, customerDict, customerTypeDict }] = useModel("cmDict");
    const [{ searchParam, searchPage },{ loadListDetail,setSearchParam,resetSearchParam,setPartOrCustomerList,setPartOrCustomerStatistics}] = useModel("partOrCustomerModel");


    // useEffect(() => {
    //     form.resetFields();
    //     resetSearchParam();
    //     // onReset();
    // }, []);
    // // useEffect(() => {
    // //     form.setFieldsValue(searchParam);
    // // }, [searchParam]);

    const onFinish = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searchPage
        let data = {
            ...searchParam,            
            startTime,
            endTime,
            pageSize,
            pageNum,            
        }
        loadListDetail({ showMsg: true, data });
    }
    const onReset = () => {
        form.resetFields();
        resetSearchParam();     
        setPartOrCustomerList([])   
        setPartOrCustomerStatistics({
            saleNumTotal:0,
            aggregateAmountTotal:0,
            productionCost:0,
            grossProfit:0
        })
        // let data = {
        //     pageSize: 15,
        //     pageNum: 1,
        // }
        // loadListDetail({ showMsg: true, data })
    }
    const treeChange = (value, label, extra)=>{
        // console.log(value, label, extra)
    }
    return (
        <Form
            form={form}
            labelCol={{span: "6"}}
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Row>
                <Col span={6}>
                    <Form.Item
                        name="customerName"
                        label="客户名称"
                    >
                        <Input placeholder="客户名称" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialName"
                        label="商品名称"
                    >
                        <Input placeholder="商品名称" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialCode"
                        label="商品编号"
                    >
                        <Input placeholder="商品编号" />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="customerType"
                        label="客户类型"
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="请选择客户类型"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={customerTypeDict}
                            dropdownClassName="dark-select"
                        />
                    </Form.Item>
                </Col>

            </Row>
            <Row>
            <Col span={6}>
                    <Form.Item
                        name="saleCode"
                        label="销售单号"
                    >
                        <Input placeholder="销售单号" />
                    </Form.Item>
                </Col>                
                <Col span={6}>
                    <Form.Item
                        name="categorys"
                        label="商品类型"
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="请选择商品类型"
                            treeDefaultExpandAll
                            multiple
                            onChange={treeChange}
                            treeData={materialSortDict}
                            dropdownClassName="dark-select"

                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="checkTime" label="结算日期" {...rangeConfig}>
                        <RangePicker/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item shouldUpdate={true}>
                        {() => (
                            <>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    查询
                        </Button>
                                <Button
                                    htmlType="button"
                                    className="margin-left-8"
                                    onClick={onReset}
                                >
                                    重置
                        </Button>
                            </>
                        )}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}